var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClothRecolorNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1280 1280",
    style: {
      enableBackground: "new 0 0 1280 1280"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#5B6673;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1280,
    height: 1280
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1035.7,169.4L846,66c-2.3-1.3-5-2-7.7-2H682.1c0,70.6-57.5,128-128.1,128S425.9,134.6,425.9,64H269.7 c-2.7,0-5.3,0.7-7.7,2L72.3,169.4c-6,3.3-9.2,9.9-8.1,16.6l36.1,216.6c1.3,7.7,8,13.4,15.8,13.4h149.7v400c0,8.8,7.2,16,16,16 h544.4c8.8,0,16-7.2,16-16V416h149.7c7.8,0,14.5-5.6,15.8-13.4l36.1-216.6C1044.9,179.3,1041.6,172.6,1035.7,169.4z M951.2,352 h-173v416H329.8V352h-173L133,209.2L282,128h90.9c26.4,74.5,97.6,128,181.1,128s154.7-53.5,181.2-128H826l149,81.2L951.2,352z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1188.7,689.9c-18.9-47.2-46.9-90.2-82.4-126.5c-54.2-55.9-124.3-93.8-200.8-108.4c-4.3-0.8-8.5,2.1-9.3,6.4 c-0.1,0.5-0.1,1-0.1,1.5v49c0,3.7,2.6,7,6.2,7.8c60.2,13.4,115.3,44.1,158.2,88.4c60.4,61.9,93.8,146.4,91.6,231.8 c-0.8,31-26.8,56.2-58,56.2H929.2c-52.8,0-96.7,42.2-97.2,95c-0.5,53.1,42.2,96.5,95.2,97c0.3,0,0.5,0,0.8,0h0.3 c18.9,0,22.9,15.3,23.7,20.1s2,20.5-15.8,26.6c-33.5,11.5-68.7,17.4-104.1,17.3c-152.3,0-280.1-107-312.2-249.8 c-0.8-3.6-4-6.2-7.8-6.2h-49.1c-4.4,0-8,3.6-8,8c0,0.5,0,1,0.1,1.5c40.8,208.3,242.8,344.2,451.1,303.4 c17.2-3.4,34.2-7.9,50.8-13.6c21.7-7.5,38.7-21.6,49-40.8c18.9-35.9,11.5-80-18-107.9c-16-14.8-36.7-22.6-59.6-22.6H928 c-17.5,0-31.7-14-32-31.5c-0.3-17.9,14.7-32.5,32.6-32.5h165.5c66.1,0.1,120.2-52.5,122-118.6 C1217.4,789.6,1208.1,738,1188.7,689.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1024,
    cy: 768,
    r: 64
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClothRecolorNormal);
export default __webpack_public_path__ + "static/media/clothRecolor_normal.e3a30d26340572d0349bd075ef85b107.svg";
export { ForwardRef as ReactComponent };